import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiPhone } from 'react-icons/fi';
import useScrollAnimation from '../../hooks/useScrollAnimation';

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <section className="py-12 sm:py-16 lg:py-20 relative overflow-hidden">
      {/* Blue → Indigo gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-500 to-secondary-600" />
      {/* sky blue glow at bottom */}
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-accent-500/20 rounded-full blur-3xl" />
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-white/5 rounded-full blur-3xl" />

      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}
        className="absolute -top-12 -right-12 w-56 h-56 border-2 border-white/15 rounded-full"
      />
      <motion.div
        animate={{ rotate: -360 }}
        transition={{ duration: 40, repeat: Infinity, ease: 'linear' }}
        className="absolute -bottom-16 -left-16 w-80 h-80 border border-white/10 rounded-full"
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <p className="text-white/70 font-bold text-xs uppercase tracking-widest mb-3">
            Join Our School Family
          </p>
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-serif font-bold text-white mb-4">
            Enroll Your Child Today
          </h2>
          <p className="text-white/80 text-sm sm:text-lg mb-3 max-w-2xl mx-auto">
            Give your child the best start in life with Gyanpunja English Boarding Secondary School's world-class education.
            Admissions are now open for the 2025–2026 academic year.
          </p>
          <p className="text-white/55 text-sm mb-10">
            Limited seats available. Early applications are encouraged.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/admissions/apply"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-primary-600 rounded-xl font-bold transition-all hover:-translate-y-0.5 shadow-xl hover:shadow-2xl text-base hover:bg-primary-50"
            >
              Apply Now <FiArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/15 text-white border-2 border-white/40 rounded-xl font-bold hover:bg-white/25 transition-all hover:-translate-y-0.5 text-base"
            >
              <FiPhone className="w-5 h-5" /> Contact Us
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
